<fury-page>
    <fury-title class="title">
        <h2>{{authorId ? 'Update' : 'Add'}} Author</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="authorForm" style="width: 100%;">

          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec">
                  <div class="imgsec">
                    <img [src]="imagestoupload ?  imagestoupload : '../../../../../assets/img/no_thumbnail.jpg'" alt="Author image">
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #galleryImage (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button type="button" class="uploadfilebtn" mat-raised-button (click)="galleryImage.click()">Upload a Image</button>
                  </div>
                  <mat-error *ngIf="authorForm.controls['profilePicture'].touched && authorForm.controls['profilePicture'].hasError('required')">
                    This is a required field.</mat-error>
                </div>
              </div>
            </div>
            </fxLayout>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput placeholder="Name" (keyup)="apiService.restrictChar($event, 255)" formControlName="fullName">
              <mat-error *ngIf="authorForm.controls['fullName'].touched && authorForm.controls['fullName'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Designation</mat-label>
              <input matInput placeholder="Designation" (keyup)="apiService.restrictChar($event, 255)" formControlName="designation">
              <mat-error
                *ngIf="authorForm.controls['designation'].touched && authorForm.controls['designation'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Linkedin link</mat-label>
              <input matInput placeholder="Linkedin link" formControlName="linkedinUrl">
              <mat-hint>Example: https://www.linkedin.com/in/xxxxxx</mat-hint>
              <mat-error
                *ngIf="authorForm.controls['linkedinUrl'].touched && authorForm.controls['linkedinUrl'].hasError('required')">
                This is a required field.</mat-error>
              <mat-error
                *ngIf="authorForm.controls['linkedinUrl'].touched && authorForm.controls['linkedinUrl'].hasError('pattern')">
                Invalid Link</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput placeholder="Description" formControlName="description"></textarea>
              <mat-error
                *ngIf="authorForm.controls['description'].touched && authorForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </div>
            
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="submit()"><span>{{authorId ? 'Update' : 'Add'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
  
           
            
          </form>
    </div>
  </div>


